
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHydraulic11On as ObiHydraulic11OnElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-hydraulic-11-on.js';
 
 
 

 
 export const ObiHydraulic11On = createComponent({
   react: React,
   tagName: 'obi-hydraulic-11-on',
   elementClass: ObiHydraulic11OnElement,
   events: {
     
   }
  });
 
 